
import { defineComponent, onBeforeUnmount, onMounted, ref } from "vue";
import { onKeyStroke } from "@vueuse/core";
import Icon from "@moonlight/vue3/components/Icon.vue";
export default defineComponent({
  components: {
    Icon,
  },
  props: {
    src: { type: String, required: true },
  },
  setup(props, context) {
    // visibility
    onMounted(() => {
      document.body.style.overflow = "hidden";
    });
    onBeforeUnmount(() => {
      document.body.style.overflow = "";
    });

    // keyboard
    onKeyStroke("Escape", () => {
      context.emit("close");
    });

    // focus navigation
    const root = ref<HTMLElement | null>(null);
    onMounted(() => {
      root.value?.focus();
    });

    return {
      root,
      videoSrc:
        props.src?.substr(-4) == ".mp4" ? props.src : props.src + ".mp4",
    };
  },
});
